import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M10.777 8.157a2.264 2.264 0 0 1 3.412 1.956c0 .643-.49 1.203-1.163 1.652a6.093 6.093 0 0 1-1.26.634l-.018.006-.003.002a.566.566 0 0 0-.386.536v.944a.566.566 0 1 0 1.132 0v-.557l.106-.046a7.21 7.21 0 0 0 1.057-.577c.741-.495 1.667-1.35 1.667-2.594a3.396 3.396 0 0 0-6.6-1.131.566.566 0 0 0 1.068.376 2.26 2.26 0 0 1 .988-1.201Zm.421 8.56c0-.443.36-.802.802-.802h.01a.802.802 0 1 1 0 1.604H12a.802.802 0 0 1-.802-.802Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM3.132 12a8.868 8.868 0 1 1 17.736 0 8.868 8.868 0 0 1-17.736 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
